const PREFER_EMAIL_CODE_KEY = "adatis.auth.preferEmailCode";
const PREFER_REGISTER_EMAIL_CODE_KEY = "adatis.auth.preferRegisterEmailCode";

export const getPreferEmailCode = (): boolean => {
  try {
    return localStorage.getItem(PREFER_EMAIL_CODE_KEY) === "1";
  } catch {
    return false;
  }
};

export const setPreferEmailCode = (prefer: boolean): void => {
  try {
    if (prefer) {
      localStorage.setItem(PREFER_EMAIL_CODE_KEY, "1");
      return;
    }

    localStorage.removeItem(PREFER_EMAIL_CODE_KEY);
  } catch {
    // localStorage unavailable
  }
};

export const getPreferRegisterEmailCode = (): boolean => {
  try {
    return localStorage.getItem(PREFER_REGISTER_EMAIL_CODE_KEY) === "1";
  } catch {
    return false;
  }
};

export const setPreferRegisterEmailCode = (prefer: boolean): void => {
  try {
    if (prefer) {
      localStorage.setItem(PREFER_REGISTER_EMAIL_CODE_KEY, "1");
      return;
    }

    localStorage.removeItem(PREFER_REGISTER_EMAIL_CODE_KEY);
  } catch {
    // localStorage unavailable
  }
};
